export default "__VITE_ASSET__52e33cf9__"